<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <div id="step">
      <el-steps :active="0" style="width: 135%;">
        <el-step title="家长填写需求"></el-step>
        <el-step title="等待老师投递"></el-step>
        <el-step title="查看并挑选合适的老师"></el-step>
        <el-step title="联系平台客服并预约试讲"></el-step>
      </el-steps>
    </div>

    <div class="flex" style="margin-top: .1563rem;width: 1.3438rem;">
      <img src="../../assets/SsendHead.png" style="width: .0625rem;height: .0703rem;margin-top: .026rem;" alt="">
      <div class="sendtitle">家长称呼</div>
      <input type="text" class="emptyinput" style="width: .8854rem;" placeholder="请输入" v-model="parentName">
    </div>
    <div class="flex" style="margin-top: .0781rem;width: 1.3438rem;position: relative;">
      <img src="../../assets/TjianliPhone.png" style="width: .0625rem;height: .0703rem;margin-top: .026rem;" alt="">
      <div class="sendtitle">联系方式</div>
      <input type="text" class="emptyinput" style="width: .8854rem;" placeholder="请输入电话号码" v-model="phone"
        :disabled="truephone != ''">
      <button class="button" style="position: absolute;left: 1.44rem;top: -0.12rem;" @click="yanzhengma"
        v-if="truephone == ''">{{
        yanzhengmatext
      }}</button>

    </div>
    <div class="flex" style="margin-top: .0781rem;width: 1.8438rem;" v-if="truephone == ''">
      <img src="../../assets/TjianliPhone.png" style="width: .0625rem;height: .0703rem;margin-top: .026rem;" alt="">
      <div class="sendtitle">验证码</div>
      <input type="text" class="emptyinput" style="width: .8854rem;" placeholder="请输入电话号码" v-model="phonecode">
      <button class="button" style="margin-top: 0;margin-left: 0.1rem;" @click="yanzhengcode">验证</button>

    </div>
    <div class="flex" style="margin-top: .0781rem;width: 1.3438rem;">
      <img src="../../assets/SsendSex.png" style="width: .0677rem;height: .0703rem;margin-top: .026rem;" alt="">
      <div class="sendtitle">学生性别</div>
      <template>
        <el-radio-group v-model="studentGender" text-color="#606266" style="width: .8854rem;">
          <el-radio :label="1">女</el-radio>
          <el-radio :label="0">男</el-radio>
        </el-radio-group>
      </template>
    </div>
    <div style="display: flex; margin-top: .0781rem; width: 1.8rem;justify-content: space-between;">
      <img src="../../assets/TjianliClass.png" alt=""
        style="transform: translateY(.0156rem);width: .0625rem;height: .0729rem;">
      <div class="sendtitle">上课内容</div>
      <div class="fanwei">
        <template>
          <div>
            <div v-for="(cascader, index) in  fanweichecked " :key="index">
              <el-cascader v-model="cascader.value" :options="fanwei" placeholder="请选择" :style="{
        width: '.8854rem', height: '.125rem', margin: '.0365rem 0', transform: 'translateY(-0.0317rem)'
      }"></el-cascader>
              <!-- 如果是最后一个选择器组，就显示加号按钮 -->
              <!-- <el-button v-if="index === fanweichecked.length - 1" type="primary" icon="el-icon-plus" circle -->
              <!-- v-on:click="addCascader" -->
              <!-- :style="{ backgroundColor: 'rgb(1, 162, 153)', width: '.0781rem', height: '.0781rem', padding: '0', fontSize: '.026rem', transform: 'translateY(-0.0625rem)' }"></el-button> -->
              <!-- 如果不是第一个选择器组，就显示删除按钮 -->
              <!-- <el-button v-else type="danger" icon="el-icon-close" circle v-on:click="deleteCascader(index)" -->
              <!-- :style="{ width: '.0781rem', height: '.0781rem', padding: '0', fontSize: '.026rem', transform: 'translateY(-0.0625rem)' }"></el-button> -->
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="flex" style="justify-content: space-between;margin: 0rem 0 .0833rem 0;width: 1.3438rem;"
      v-if="this.ifshowgrade == 1">
      <img src="../../assets/TjianliClass.png" alt=""
        style="width: .0573rem;height: .0729rem;transform: translateY(.0208rem);">
      <div class="sendtitle">
        <div>所在年级</div>
      </div>
      <div id="location">
        <el-select v-model="gradeId" placeholder="请选择" :style="{ width: '.8854rem' }">
          <el-option v-for="item in  this.grade " :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="flex" style="justify-content: space-between;margin: 0rem 0 .0833rem 0;width: 1.3438rem;">
      <img src="../../assets/SsendLocation.png" alt=""
        style="width: .0573rem;height: .0729rem;transform: translateY(.0208rem);">
      <div class="sendtitle">
        <div>授课区域</div>
      </div>
      <div id="location">
        <el-select v-model="locationchecked" placeholder="请选择" :style="{ width: '.8854rem' }">
          <el-option v-for="item in  this.location " :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="flex" style="margin-top: .0781rem;width: 2.3542rem;">
      <img src="../../assets/TjianliSchool.png"
        style="width: .0677rem;height: .0781rem;margin-top: .026rem;transform: translateY(-0.0104rem);" alt="">
      <div class="sendtitle">详细地址</div>
      <input type="text" class="emptyinput" style="width: 2.1458rem;" placeholder="示例：**街道**小区**栋" v-model="address">
    </div>
    <div class="flex" style="width: 2.8854rem;margin-top: .0781rem;transform: translateY(0.025rem);" id="quyu">
      <img src="../../assets/TjianliTime.png" style="width: .0729rem;height: .0729rem; transform: translateY(.0208rem);"
        alt="">
      <div>
        <div class="sendtitle" style="width: .35rem;">授课时间</div>
      </div>
      <el-select v-model="studytimechecked" placeholder="请选择" multiple :collapse-tags="ifcollapsetime"
        :style="{ width: '2.6948rem', height: '.177rem' }" style="transform: translateY(-0.025rem);">
        <el-option v-for="item in studytime" :key="item.value" :value="item.value" :label="item.label">
        </el-option>
      </el-select>
    </div>
    <div class="flex" style="justify-content: space-between;margin: .0781rem 0 0rem 0;width: 2.3854rem;">
      <img src="../../assets/SsendRicheng.png" alt=""
        style="width: .0729rem;height: .0729rem;transform: translateY(.0156rem);">
      <div class="sendtitle">
        <div>补习日程</div>
      </div>
      <div class="block">
        <el-date-picker v-model="timeqasd" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" :style="{ width: '1.8333rem', height: '.125rem' }">
        </el-date-picker>
      </div>
    </div>
    <div class="flex" style="margin-top: .1063rem;width: 1.6438rem;"><img src="../../assets/TjianliMoney.png" alt=""
        style="width: .0729rem;height: .0729rem; transform: translateY(.0108rem);">
      <div class="sendtitle">课时费</div><input type="text" class="emptyinput" style="width: .8854rem;" placeholder="请输入"
        v-model="price">
      <div style="width: 0.3rem;line-height: 0.13rem;margin-left: .05rem;" class="sendtitle">元/小时</div>
    </div>
    <div class="flex" style="margin-top: .0863rem;width: 1.3438rem;justify-content: left;">
      <img src="../../assets/sendtoux.png" alt=""
        style="width: .0729rem;height: .0829rem; transform: translateY(.0108rem);">
      <div class="sendtitle">学生情况</div>
    </div>
    <el-input type="textarea" :rows="2" placeholder="请描述一下您的孩子的基本情况" v-model="studentLearningSituation"
      style="margin-top: .05rem;">
    </el-input>
    <div class="flex" style="margin-top: .0863rem;width: 1.3438rem;justify-content: left;">
      <img src="../../assets/sendlasohi.png" alt=""
        style="width: .0729rem;height: .0629rem; transform: translateY(.0208rem);">
      <div class="sendtitle">对老师的要求</div>
    </div>
    <el-input type="textarea" :rows="2" placeholder="请描述一下您对老师的要求" v-model="request" style="margin-top: .05rem;">
    </el-input>
    <div class="flex" style="width: .64rem;margin-top: 0.0781rem;"><img src="../../assets/Tjianliyingxing.png" alt=""
        style="width: .085rem;height: .07rem; transform: translateY(0.02rem); ">
      <div class="sendtitle" style="width: .6rem;">
        <div>硬性要求</div>
      </div>
    </div>
    <div class="flex" style="margin-top: .0781rem;width: 1.5438rem;">
      <div class="sendtitle" style="transform: translateY(-0.02rem);">老师性别</div>
      <template>
        <el-radio-group v-model="teacherGender" text-color="#606266" style="width: 1.3854rem;">
          <el-radio :label="1">女</el-radio>
          <el-radio :label="0">男</el-radio>
          <el-radio :label="2">不限</el-radio>
        </el-radio-group>
      </template>
    </div>
    <div class="flex" style="justify-content: space-between;margin: .0625rem 0 0rem 0;width: 1.2396rem;">
      <div class="sendtitle">
        <div>老师类型</div>
      </div>
      <div class="answer">
        <div id="location">
          <el-select v-model="teacherType" placeholder="请选择" :style="{ width: '.8854rem' }">
            <el-option v-for=" item  in  this.teacherTypelist " :key="item.value" :value="item.value"
              :label="item.label">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="flex" style="justify-content: space-between;margin: .0625rem 0 0rem 0;width: 1.2396rem;">
      <div class="sendtitle">
        <div>辅导方式</div>
      </div>
      <div class="answer">
        <div id="location">
          <el-select v-model="teachMethodchecked" placeholder="请选择" :style="{ width: '.8854rem' }">
            <el-option v-for=" item  in  this.teachMethod " :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>

    <button class="button" @click="submit">提交需求</button>
    <div style="height: 100px;"></div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'

export default {
  data() {
    return {
      hash: '',
      truephone: '',
      yanzhengmatext: '获取验证码',
      phonecode: '',
      ifcollapsetime: false,
      address: '',
      classHours: '',
      parentName: '',
      phone: '',
      studentGender: '',
      price: 0,
      studytime: [
        {
          value: 0,
          label: '周一到周五晚上'
        }, {
          value: 1,
          label: '周一到周五全天'
        }, {
          value: 2,
          label: '周六上午'
        }, {
          value: 3,
          label: '周六下午'
        }, {
          value: 4,
          label: '周六晚上'
        }, {
          value: 5,
          label: '周日上午'
        }, {
          value: 6,
          label: '周日下午'
        }, {
          value: 7,
          label: '周日晚上'
        }, {
          value: 8,
          label: '寒暑假均可'
        },],
      studytimechecked: [],
      fanweichecked: [
        // 初始有一个选择器组
        {
          value: [],
        },
      ],
      fanwei: [
        // 这里是级联选择器的数据源，你可以根据你的需求修改
        {
          value: "1",
          label: "小学",
          children: [
            {
              value: "0",
              label: "全科",
            },
            {
              value: "1",
              label: "语文",
            },
            {
              value: "2",
              label: "奥数",
            },
            {
              value: "3",
              label: "数学",
            },
            {
              value: "4",
              label: "英语",
            },
            {
              value: "5",
              label: "作业辅导",
            },

          ],
        },
        {
          value: "2",
          label: "初中",
          children: [
            {
              value: "0",
              label: "全科",
            },
            {
              value: "1",
              label: "语文",
            },
            {
              value: "2",
              label: "英语",
            },
            {
              value: "3",
              label: "数学",
            },
            {
              value: "4",
              label: "物理",
            },
            {
              value: "5",
              label: "化学",
            },

          ],
        },
        {
          value: "3",
          label: "高中",
          children: [
            {
              value: "0",
              label: "数学",
            },
            {
              value: "1",
              label: "语文",
            },
            {
              value: "2",
              label: "英语",
            },
            {
              value: "3",
              label: "物理",
            },
            {
              value: "4",
              label: "化学",
            },
            {
              value: "5",
              label: "生物",
            },
            {
              value: "6",
              label: "历史",
            },
            {
              value: "7",
              label: "政治",
            },
            {
              value: "8",
              label: "地理",
            },

          ],
        },
        {
          value: "4",
          label: "小语种",
          children: [
            {
              value: "0",
              label: "法语",
            },
            {
              value: "1",
              label: "德语",
            },
            {
              value: "2",
              label: "西班牙语",
            },
            {
              value: "3",
              label: "日语",
            },
            {
              value: "4",
              label: "葡萄牙语",
            },
            {
              value: "5",
              label: "韩语",
            },

          ],
        },
        {
          value: "5",
          label: "艺体类",
          children: [
            {
              value: "0",
              label: "音乐",
            },
            {
              value: "1",
              label: "美术",
            },
            {
              value: "2",
              label: "舞蹈",
            },
            {
              value: "3",
              label: "体育",
            },
          ],
        }, {
          value: "60",
          label: "其他",

        },
      ],
      location: [{
        value: 0,
        label: '锦江区'
      }, {
        value: 1,
        label: '金牛区'
      }, {
        value: 2,
        label: '武侯区'
      }, {
        value: 3,
        label: '青羊区'
      }, {
        value: 4,
        label: '成华区'
      }, {
        value: 5,
        label: '高新区'
      }, {
        value: 6,
        label: '天府新区'
      }, {
        value: 7,
        label: '新都区'
      }, {
        value: 8,
        label: '郫都区'
      }, {
        value: 9,
        label: '双流区'
      }, {
        value: 10,
        label: '龙泉驿区'
      }, {
        value: 11,
        label: '温江区'
      }, {
        value: 13,
        label: '都江堰'
      }, {
        value: 14,
        label: '彭州'
      }, {
        value: 15,
        label: '邛崃'
      }, {
        value: 16,
        label: '崇州'
      }, {
        value: 17,
        label: '简阳'
      }, {
        value: 18,
        label: '金堂'
      }, {
        value: 19,
        label: '大邑'
      }, {
        value: 20,
        label: '蒲江'
      }, {
        value: 21,
        label: '新津'
      }, {
        value: 22,
        label: '青白江'
      },
      {
        value: 12,
        label: '其他'
      },],
      grade: [{
        value: 0,
        label: '小学'
      },
      {
        value: 1,
        label: '初中'
      },
      {
        value: 2,
        label: '高中'
      }],
      gradeId: 0,
      locationchecked: '',
      timeqasd: [],

      // teachMethod: ['不限', '老师上门辅导', '线上辅导'],
      teachMethod: [{
        value: 0,
        label: '老师上门辅导'
      },
      {
        value: 1,
        label: '线上辅导'
      },
      {
        value: null,
        label: '不限'
      }
      ],
      teachMethodchecked: 0,
      teacherGender: 0,
      studentLearningSituation: '',
      request: '',
      teacherType: "0",
      // teacherTypelist: ['专职教师', '在读本科生', '在读研究生'],
      teacherTypelist: [{
        value: "0",
        label: '专职教师'
      }, {
        value: "1",
        label: '在读本科生'
      }, {
        value: "2",
        label: '在读研究生'
      }],
      Authorization: '',
      ifshowgrade: 0
    }
  },
  watch: {
    studytimechecked() {
      if (this.studytimechecked.length > 4) {
        this.ifcollapsetime = true
      }
      else {
        this.ifcollapsetime = false
      }
    },

    fanweichecked: {
      handler(newVal, oldVal) {
        if (this.fanweichecked[0].value[0] == 4 || this.fanweichecked[0].value[0] == 5 || this.fanweichecked[0].value[0] == 60) {
          this.ifshowgrade = 1
          console.log(this.ifshowgrade);
        } else {
          this.ifshowgrade = 0
          if (this.fanweichecked[0].value[0] == 1) {
            this.gradeId = 0
          }
          if (this.fanweichecked[0].value[0] == 2) {
            this.gradeId = 1
          } if (this.fanweichecked[0].value[0] == 3) {
            this.gradeId = 2
          }
        }

      },
      deep: true

    },
  },
  methods: {
    yanzhengma() {
      if (this.phone == '') {
        this.$message({
          message: '请输入手机号',
          type: 'warning'
        });
        return false
      }
      let time = 60
      let timer = setInterval(() => {
        this.yanzhengmatext = time + 's'
        time--

        if (time == 0) {
          clearInterval(timer)
          this.yanzhengmatext = '获取验证码'
        }
      }, 1000);
      let formData = new FormData();
      formData.append('phone', this.phone);
      this.$http.post('/Api/User/User/Web/Phone/Verify', formData, {
        headers: {
          'Authorization': this.Authorization,
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log(res);
        if (res.data.msg == 'SUCCESS') {
          this.$message({
            message: '验证码已发送',
            type: 'success'
          });
        } else {
          this.$message({
            message: '验证码发送失败',
            type: 'error'
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },
    yanzhengcode() {
      if (this.phonecode == '') {
        this.$message({
          message: '请输入验证码',
          type: 'warning'
        });
        return false
      }
      let formData = new FormData();
      formData.append('code', this.phonecode);
      this.$http.post('/Api/User/User/Web/Phone/Verify/Callback', formData, {
        headers: {
          'Authorization': this.Authorization,
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log(res);
        if (res.data.msg == 'SUCCESS') {
          this.$message({
            message: '验证成功',
            type: 'success'
          });
          localStorage.setItem('phone', this.phone)
        } else {
          this.$message({
            message: '验证失败',
            type: 'error'
          });
        }
      }).catch(err => {
        console.log(err);
      });
    },

    // addItem() {
    //   // 这里从select组件中获取当前选中的值
    //   let currentValue = this.$refs.select.value;
    //   // 判断是否已经存在于selectedItems中
    //   if (this.selectedItems.includes(currentValue)) {
    //     // 如果已经存在，就提示用户
    //     ElMessage.warning("该条目已经存在");
    //   } else {
    //     // 如果不存在，就添加进去，并提示用户
    //     this.selectedItems.push(currentValue);
    //     ElMessage.success("添加成功");
    //   }
    // },
    // addCascader() {
    //   if (this.fanweichecked.length == 3) {
    //     this.$message({
    //       message: '最多3个科目哦~~',
    //       type: 'warning'
    //     });

    //   }
    //   else {
    //     this.fanweichecked.push({
    //       value: [],
    //     });
    //   }

    // },
    // deleteCascader(index) {
    //   // 点击删除按钮后，判断是否可以删除该选择器组
    //   if (this.fanweichecked.length > 1) {
    //     // 如果选择器组数量大于1，就从fanweichecked数组中移除该对象，并提示用户
    //     this.fanweichecked.splice(index, 1);
    //   } else {
    //     // 如果选择器组数量等于1，就不能删除，并提示用户
    //     ElMessage.warning("不能删除");
    //   }
    // },
    submit() {
      // for (let key in this.$data) {
      //   if (this.$data[key] === '' || this.$data[key] == null) {
      //     console.error(`The ${key} field is empty`);
      //     this.$message.error('您输入的信息不完整哦~');
      //     return false;
      //   }
      // }

      let newdata = {}
      // this.$router.push('/personteacher/jianlisucces')
      newdata.address = this.address
      let itemId = 0
      this.fanweichecked.forEach((item, index) => {
        let a = item.value[0] + item.value[1]
        let b = parseInt(a)
        itemId = b
      })
      // console.log(this.timeqasd.join('-'));
      newdata.itemId = itemId
      newdata.parentName = this.parentName
      newdata.phone = this.phone
      newdata.price = this.price
      newdata.studentLearningSituation = this.studentLearningSituation
      newdata.studentGender = this.studentGender
      newdata.studyArea = this.locationchecked
      newdata.studyTimes = this.studytimechecked
      let period = this.timeqasd.join('-')
      newdata.period = period
      newdata.request = this.request
      newdata.isOnline = this.teachMethodchecked
      newdata.teacherGender = this.teacherGender
      newdata.teacherType = this.teacherType
      newdata.gradeId = this.gradeId
      newdata.classHours = '123'
      console.log(JSON.stringify(newdata));
      if (!(this.hash)) {
        this.$http.post('/Api/Parent/Demand', JSON.stringify(newdata), {
          headers: {
            'Authorization': this.Authorization,
            'Content-Type': 'application/json'
          }
        }).then(res => {
          console.log(res);
          if (res.data.code == 200) {
            this.$message({
              message: '发布成功',
              type: 'success'
            });
            setTimeout(() => {
              this.$router.push('/personstudent/success#3')

            }, 1000);
          }
          else if (res.data.code == 302) {
            this.$message({
              message: res.data.data[0].defaultMessage,
              type: 'error'
            });
          }

        }).catch(err => {
          // console.log(err);
          this.$message({
            message: err,
            type: 'error'
          });
        })
      }
      else {
        console.log(this.hash);
        newdata.did = this.hash
        this.$http.put('/Api/Parent/Demand/' + this.hash, JSON.stringify(newdata), {
          headers: {
            'Authorization': this.Authorization,
            'Content-Type': 'application/json'
          }
        }).then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            });
            setTimeout(() => {
              this.$router.push('/personstudent/success#3')

            }, 1000);
          }
        }).catch(err => {
          // console.log(err);
        })
      }
    }
  },
  created() {
    if (localStorage.getItem('phone')) {
      this.phone = localStorage.getItem('phone')
      this.truephone = localStorage.getItem('phone')
    }
    this.hash = this.$route.hash.slice(1)
    this.Authorization = localStorage.getItem('Authorization')
    if (this.hash) {
      this.$http.get('/Api/Parent/Demand/' + this.hash, {
        headers: {
          'Authorization': this.Authorization,
        }
      }).then(res => {
        console.log(res);
        this.address = res.data.data.address
        this.parentName = res.data.data.parentName
        this.phone = res.data.data.phone
        this.price = res.data.data.price
        this.studentLearningSituation = res.data.data.studentLearningSituation
        this.studentGender = res.data.data.studentGender
        this.locationchecked = res.data.data.studyArea
        this.studytimechecked = res.data.data.studyTimes
        this.timeqasd = res.data.data.period.split('-')
        this.request = res.data.data.request
        this.teachMethodchecked = res.data.data.isOnline
        this.teacherGender = res.data.data.teacherGender
        let arr = [{
          value: [res.data.data.itemId.toString().slice(0, 1), res.data.data.itemId.toString().slice(1, 2)],
        }]
        this.fanweichecked = arr
      }).catch(err => {
        console.log(err);
      })
    }
    // let str = this.timeqasd.join('-')

  }


}

</script>

<style scoped>
#quyu /deep/ .el-select .el-input__inner {
  height: 34px;
}

/deep/ .el-cascader .el-input .el-input__inner,
/deep/ .el-select .el-input__inner {
  height: 24px;
}

/deep/ .el-cascader .el-input .el-icon-arrow-down {
  position: relative;
  font-size: 14px;
  width: 24px;
  height: 24px;
}

/deep/ .el-cascader .el-input .el-icon-arrow-down::before {
  position: absolute;
  top: -5px;
  left: 0;
  width: 100%;
  height: 100%;
}

/deep/ .el-icon-arrow-up:before {
  content: "\E6E1";
  position: absolute;
  top: -6px;
  left: 5px;
}

/deep/ .el-icon-close:before {
  position: absolute;
  content: "\E6DB";
  top: 1px;
  left: 1px;
}



/deep/ .el-icon-plus:before {
  position: absolute;
  content: "\E6D9";
  top: 1px;
  left: 1px;
}


input {
  width: 100%;
  height: 100%;
}

/deep/ .el-icon-date:before {
  content: "\E78E";
  position: absolute;
  top: -4px;
}

/deep/ .el-date-editor .el-range-separator {
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  height: 24px;
}

.flex {
  display: flex;
  justify-content: space-between;
  width: auto;
}

#step {
  width: 800px !important;
}

#step /deep/ .el-step__head.is-process {
  color: #fff;
}

#step /deep/ .el-step__head.is-process .el-step__icon.is-text {
  background-color: rgb(1, 162, 153);
  border: none;
}

#step /deep/ .el-step__title.is-process {
  color: rgb(1, 162, 153) !important;
}

.emptyinput {
  /* input-完整/small/default/无/off/off/off/off/off (style) */
  width: 170px;
  height: 24px;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgb(220, 223, 230);
  border-radius:
    4px;
  padding-left: 10px;
}


.emptyinput::placeholder {
  color: rgb(168, 171, 178);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  height: 24px;
}

.emptyinput:focus {
  background: rgb(255, 255, 255);
  outline: 1px solid rgb(220, 223, 230);
}

.sendtitle {
  /* 联系方式 */
  width: 80px;
  height: 20px;
  color: rgb(48, 49, 51);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: left;
  margin-left: 5px;
}

.fanwei {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  width: 290px;
  transform: translateY(-5px);
}

.fanwei img {
  margin-left: 15px;
  margin-bottom: 12px;
}

.title img {
  width: 18px;
  height: 18px;
  transform: translateY(4px);
}


th {
  width: 40px;
  height: 40px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;


}

table {
  border-collapse: collapse;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  margin-top: 10px;
  margin-left: 21px;
}



tr {
  border: none;
  width: 40px;
  height: 36px;
  color: rgb(96, 98, 102);
  font-family: 苹方;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.009999999776482582px;
  text-align: center;

}


.checkbox {
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  margin-right: 10px;
}

.checkbox input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  top: 2px;
  left: 6px;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  background-color: transparent;
  border: none;
}

.checkbox input:checked+.checkmark {
  background-color: #01A299;
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.checkbox input:checked+.checkmark:after {
  display: block;
}

.checkmark:after {
  left: 5px;
  top: 2px;
  width: 3px;
  height: 6px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.button {
  width: 90px;
  height: 32px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0px;
  text-align: center;
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/studentsend.vue